/*
本项目特有方法库
本项目内包含的全局方法可在此声明
 */

import Vue from 'vue'
import { Loading } from 'element-ui';

(function(owner) {

    function dataCheck(data, cb) {
        var keys = Object.keys(data),
            map = {};
        if(keys.length) {
            map = keys.reduce((reMap, key) => {
                var value = data[key];
                if(getType(value) === 'string' && /{|}|\[|\]/.test(value)) {
                    try {
                        value = JSON.parse(data[key]);
                    } catch(e) {
                        value = data[key];
                    };
                };                
                reMap[key] = value;

                return reMap;
            }, {});

            cb && cb(map);
        } else {
            cb && cb(data);
        };
    }

    /**
     * jsp页面初始化方法
     * @param  {String}   url   原jsp页面对应地址
     * @param  {Object}   query 请求参数
     * @param  {Function} cb    请求成功回调函数
     * @return {undefined}         undefined
     */
    owner.jspInit = function(url, query, cb) {
        let loadingInstance = Loading.service({
            target: '#view-content',
            lock: true,
            fullscreen: false
        });

        var that = this;
        return (function() {
            that.$ajax({
                url,
                data: query,
                callback: data => {
                    dataCheck(data, cb);
                },
                complete: () => {
                    loadingInstance.close();
                }
            });
        } ());
    };

    window.jspInit = function(url, data, callback) {
        AjaxRequest({
            url: url,
            data: data,
            callback(data) {
                dataCheck(data, callback);
            }
        })
    };

    function jspDataInit(pointer, data, keyArr) {
        var point,
            fromData,
            arrToLoop;
        if(getType(data) === 'array') {
            point = this;
            fromData = pointer;
            arrToLoop = data;
        } else {
            point = pointer;
            fromData = data;
            arrToLoop = keyArr;
        };

        arrToLoop.forEach(key => {
            point[key] = fromData[key];
        });

        return true;
    }

    owner.jspDataInit = jspDataInit;
    window.jspDataInit = jspDataInit;

    /**
     * 毫秒转规范日期
     */
    owner.timePattern = function(time) {
        if(!time) return '';

        time = getType(time) === 'string' ? time.replace(/-/g, '/') : time;

        return new Date(time).pattern('yyyy-MM-dd HH:mm');
    };
} (Vue.prototype))
